// @flow
import React from 'react';
import AdresaApi from './../api/gen/adresy/AdresaApi';
import StoreSuggestField from "./StoreSuggestField";

/**
 * Field pro výběr státu.
 */
class StatField extends React.Component {

    render() {
        const {showKod} = this.props;

        return <StoreSuggestField
            apiCall={() => AdresaApi.getStaty()}
            inputProps={{placeholder: "Stát"}}
            area="shared.statField"
            getItemId={item => item ? item.kodA3 : null}
            getItemName={item => item ? (showKod ? `${item.kodA3} (${item.nazev})` : item.nazev) : ""}
            {...this.props}
        />;
    }
}

export default StatField;
